<template>
  <div class="zoom-controls absolute column">
    <div
      class="cursor-pointer q-px-16 q-pb-4 q-pt-16"
      @click="zoom(1)"
      @click.once="sendAnalytics('user_click_zoom_in')"
    >
      <q-btn
        class="q-mb-8"
        color="white"
        icon="add"
        text-color="black"
        round
      />
    </div>
    <div
      class="cursor-pointer q-px-16 q-pb-16 q-pt-4"
      @click="zoom(-1)"
      @click.once="sendAnalytics('user_click_zoom_out')"
    >
      <q-btn
        color="white"
        icon="remove"
        text-color="black"
        round
      />
    </div>
  </div>
  <div class="right-bottom-controls absolute">
    <q-btn
      color="white"
      :icon="$q.platform.is.ios ? 'near_me_alt' : 'my_location'"
      :loading="currentLocationLoading"
      text-color="black"
      round
      @click="zoomToCurrentLocation"
      @click.once="sendAnalytics('user_click_my_location')"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';

import useCurrentLocation from '~composables/useCurrentLocation';

const props = defineProps({
  map: {
    type: Object,
    default: null,
  },
});

const { startWatchLocation } = useCurrentLocation();

const currentLocationLoading = ref(false);

function sendAnalytics(event) {
  window.$logEvent?.firebase(event);
}

function zoom(value) {
  props.map.setZoom(props.map.getZoom() + value);
}

async function zoomToCurrentLocation() {
  currentLocationLoading.value = true;

  try {
    const { coords } = await startWatchLocation();

    // centering doesn't work properly without zoom in
    if (props.map.getZoom() < 2) {
      props.map.setZoom(2);
    }

    props.map.setCenter({
      lat: coords.latitude,
      lng: coords.longitude,
    });

    props.map.setZoom(13);
  } catch {
  } finally {
    currentLocationLoading.value = false;
  }
}
</script>

<style lang="scss" scoped>
.right-bottom-controls {
  bottom: 32px;
  right: 16px;
}

.zoom-controls {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
